import { css } from "@emotion/react";

export const backButtonWrapper = css`
  text-align: left;
  width: 26rem;
`;
